<script lang="ts" context="module">
  import {transition_in} from 'svelte/internal';
  import {httpClient} from '../../utils/http-client';
  import {writable} from 'svelte/store';
  import {fly} from 'svelte/transition';
  import {video} from '@/store';
  import Swal from 'sweetalert2';
  import {VideoService} from '@/services';
  let currentId: string;
  export const sermonSummaryStore = writable({
    loading: false,
    data: null,
    cachedData: null
  });
  const videoService = new VideoService();
  export function downloadSermonSummary(id: string) {
    currentId = id;
    sermonSummaryStore.set({loading: true, data: null, cachedData: null});
    const errorNoSermonSummary = () => {
      sermonSummaryStore.set({loading: false, data: null, cachedData: null});
      Swal.fire(
        'Sermon summary is not available for this sermon',
        'Sorry, we apologize for the inconvenience but only newly uploaded sermons have sermon summarys available',
        'error'
      );
    };
    const tryDownload = (retries = 0) =>
      httpClient
        .get(`/sermon-summary/${id}`)
        .then(async res => {
          let summary = res.data.result.summary;
          let summaryText = `
          Short

          ${summary.Short}

          Long

          ${summary.Long}

          YouTube

          ${summary.YouTube}

          Social Media Teaser
          
          ${summary['Social Media Teaser']}
          `;

          if (res.status == 204 && retries < 100) {
            if (currentId !== id) return;
            return setTimeout(() => {
              tryDownload(retries + 1);
            }, 2000);
          } else if (res.status == 200) {
            const url = window.URL.createObjectURL(new Blob([summaryText]));
            const link = document.createElement('a');
            const videoName = (await videoService.getVideo(id)).title;
            link.href = url;
            link.setAttribute('download', `Sermon Summary of ${videoName}.txt`);
            document.body.appendChild(link);
            link.click();
            sermonSummaryStore.set({
              loading: false,
              data: res.data.result.summary,
              cachedData: res.data.result.summary
            });
            setTimeout(() => {
              sermonSummaryStore.set({
                loading: false,
                data: null,
                cachedData: res.data.result.summary
              });
            }, 4000);
          } else {
            errorNoSermonSummary();
          }
        })
        .catch(errorNoSermonSummary);
    tryDownload();
  }
</script>

{#if $sermonSummaryStore.loading || $sermonSummaryStore.data}
  <div
    transition:fly={{y: 20}}
    class="absolute bottom-3 right-4 z-50 rounded-md bg-primary p-4 font-bold text-white shadow-md"
  >
    {#if $sermonSummaryStore.loading}
      <span class="text-xs"><span class="fa fa-spinner animate-spin" /> Loading sermon summary...</span>
    {:else}
      <span class="text-xs"><span class="fa-solid fa-circle-check" /> Sermon summary has been downloaded</span>
    {/if}
  </div>
{/if}
